// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j5ueXu {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100%;
}

.fr37oR {
  flex: 1;
  min-height: 0;
}

.VTIEQj {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  min-height: 400px;
  height: 100%;
}

.K_dYkP {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  flex: 1;
  min-height: 0;
}

.AXGoEp {
  min-width: 0 !important;
  width: 100%;
  margin: 0 !important;
  border-radius: 4px !important;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);
}

.yUwY9c {
  position: absolute;
  top: var(--spacing-3);
  right: 0;
  z-index: 1000;
  width: 320px;
  min-width: initial;
  transform: initial;
}

.sf_nhM {
  align-items: center;
  justify-content: center;
  display: flex;
  min-height: 400px;
}

.r_uJzo {
  position: fixed;
  right: 24px;
  top: 64px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
}

.v5r7CT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-1, 8px);
  padding: var(--spacing-1, 8px) var(--spacing-2, 12px);
  border: 0;
  border-radius: var(--radius-s, 4px);
  background: transparent;
  color: var(--text-primary-medium);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--type-label-md-font-size, 14px);
  font-weight: var(--type-label-md-font-weight, 500);
  line-height: 1;
  cursor: pointer;
}

.v5r7CT:disabled {
  opacity: var(--opacity-0-5, 0.5);
  cursor: not-allowed;
}

.ruWnZ6 {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .VTIEQj {
    padding: var(--spacing-2, 16px);
    gap: var(--spacing-2, 16px);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/BeneficiariesValues/BeneficiariesValues.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,qDAAqD;EACrD,SAAS;EACT,mCAAmC;EACnC,uBAAuB;EACvB,iCAAiC;EACjC,iEAAiE;EACjE,+CAA+C;EAC/C,kDAAkD;EAClD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF","sourcesContent":[".pageWrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 100%;\n}\n\n.fullHeightContentLayout {\n  flex: 1;\n  min-height: 0;\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  min-height: 400px;\n  height: 100%;\n}\n\n.stepContentEmissor {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  flex: 1;\n  min-height: 0;\n}\n\n.pendingAlert {\n  min-width: 0 !important;\n  width: 100%;\n  margin: 0 !important;\n  border-radius: 4px !important;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);\n}\n\n.validationAlertToast {\n  position: absolute;\n  top: var(--spacing-3);\n  right: 0;\n  z-index: 1000;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n\n.loadingContainer {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  min-height: 400px;\n}\n\n.alertMessage {\n  position: fixed;\n  right: 24px;\n  top: 64px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n\n.importButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-1, 8px);\n  padding: var(--spacing-1, 8px) var(--spacing-2, 12px);\n  border: 0;\n  border-radius: var(--radius-s, 4px);\n  background: transparent;\n  color: var(--text-primary-medium);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--type-label-md-font-size, 14px);\n  font-weight: var(--type-label-md-font-weight, 500);\n  line-height: 1;\n  cursor: pointer;\n}\n\n.importButton:disabled {\n  opacity: var(--opacity-0-5, 0.5);\n  cursor: not-allowed;\n}\n\n.importButtonIcon {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .stepContent {\n    padding: var(--spacing-2, 16px);\n    gap: var(--spacing-2, 16px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `j5ueXu`,
	"fullHeightContentLayout": `fr37oR`,
	"stepContent": `VTIEQj`,
	"stepContentEmissor": `K_dYkP`,
	"pendingAlert": `AXGoEp`,
	"validationAlertToast": `yUwY9c`,
	"loadingContainer": `sf_nhM`,
	"alertMessage": `r_uJzo`,
	"importButton": `v5r7CT`,
	"importButtonIcon": `ruWnZ6`
};
module.exports = ___CSS_LOADER_EXPORT___;
